var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/logo.webp"),"alt":"logo"}}),_c('p',[_vm._v(" "+_vm._s(_vm.$i18n.locale === 'english' ? 'The requested URL was not found on this server' : '在此服务器上找不到请求的URL')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }